module.exports = __webpack_public_path__ + "img/o_10.04845361.png";